import { SERVICES_SERVICE } from "@/services/services.service.js";

const state = {postServiceOutput: false, getServicesOutput: {}, putServiceOutput: false, getServiceByIdOutput: {}, deleteServiceByIdOutput: false, getServiceBySlugOutput: {}};

const actions = {
    //Service to create wines
    postService({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postServiceRequest');

        SERVICES_SERVICE.postService(input)
            .then(
                output => {
                    commit('postServiceSuccess', output);
                },
                error => {
                    commit('postServiceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated wines
    getServices({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getServicesRequest');

        SERVICES_SERVICE.getServices(queryParams)
            .then(
                output => {
                    commit('getServicesSuccess', output);
                },
                error => {
                    commit('getServicesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update wines
    putService({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putServiceRequest');

        SERVICES_SERVICE.putService(input)
            .then(
                output => {
                    commit('putServiceSuccess', output);
                },
                error => {
                    commit('putServiceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get wine details
    getServiceById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getServiceByIdRequest');

        SERVICES_SERVICE.getServiceById(id)
            .then(
                output => {
                    commit('getServiceByIdSuccess', output);
                },
                error => {
                    commit('getServiceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete wines
    deleteServiceById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteServiceByIdRequest');

        SERVICES_SERVICE.deleteServiceById(id)
            .then(
                output => {
                    commit('deleteServiceByIdSuccess', output);
                },
                error => {
                    commit('deleteServiceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get wine details
    getServiceBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getServiceBySlugRequest');

        SERVICES_SERVICE.getServiceBySlug(queryParams)
            .then(
                output => {
                    commit('getServiceBySlugSuccess', output);
                },
                error => {
                    commit('getServiceBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postService
    postServiceRequest(state) {
        state.postServiceOutput = null;
    },
    postServiceSuccess(state, output) {
        state.postServiceOutput = true;
    },
    postServiceFailure(state) {
        state.postServiceOutput = false;
    },

    //getServices
    getServicesRequest(state) {
    },
    getServicesSuccess(state, output) {
        state.getServicesOutput = output;
    },
    getServicesFailure(state) {
        state.getServicesOutput = false;
    },

    //putService
    putServiceRequest(state) {
        state.putServiceOutput = null;
    },
    putServiceSuccess(state, output) {
        state.putServiceOutput = true;
    },
    putServiceFailure(state) {
        state.putServiceOutput = false;
    },

    //getServiceById
    getServiceByIdRequest(state) {
    },
    getServiceByIdSuccess(state, output) {
        state.getServiceByIdOutput = output;
    },
    getServiceByIdFailure(state) {
        state.getServiceByIdOutput = false;
    },

    //deleteServiceById
    deleteServiceByIdRequest(state) {
        state.deleteServiceByIdOutput = null;
    },
    deleteServiceByIdSuccess(state, output) {
        state.deleteServiceByIdOutput = true;
    },
    deleteServiceByIdFailure(state) {
        state.deleteServiceByIdOutput = false;
    },

    //getServiceBySlug
    getServiceBySlugRequest(state) {
    },
    getServiceBySlugSuccess(state, output) {
        state.getServiceBySlugOutput = output;
    },
    getServiceBySlugFailure(state) {
        state.getServiceBySlugOutput = false;
    },
};

export const services = {
    namespaced: true,
    state,
    actions,
    mutations
};